'use client'

import React, { useEffect } from 'react'
import { useApiContext } from '@aw/lib'
import { useAuthToken } from '../hooks/store/useAuthToken'

interface AuthTokenProviderProps {
    children: React.ReactNode
}

export function AuthTokenProvider({ children }: AuthTokenProviderProps) {
    const { token, isLoading, refreshToken } = useAuthToken()
    const { updateConfig } = useApiContext()

    useEffect(() => {
        updateConfig({ authToken: token })
    }, [token, updateConfig])

    return <>{children}</>
}

export default AuthTokenProvider
